import { createFileRoute } from '@tanstack/react-router';
import { defaultOrganizationId } from '@nest/ids';
import { requirePermission } from '@/features/auth/access';
import { CompanyTypesPage } from '@/features/company-type/list-page';
import { PlatformWorkspace } from '@/features/tenant/platform-workspace';

export const Route = createFileRoute(
  '/_authenticated/operations/company-types',
)({
  beforeLoad: ({ context, location }) => {
    if (context.session.session.activeOrganizationId !== defaultOrganizationId)
      return;
    return requirePermission(
      context.queryClient,
      location.href,
      'companyTypes:read',
    );
  },
  component: CompanyTypesRoute,
});

function CompanyTypesRoute() {
  const { session } = Route.useRouteContext();
  return (
    <PlatformWorkspace session={session}>
      <CompanyTypesPage />
    </PlatformWorkspace>
  );
}
